import { LogLevel } from '@flagship.io/js-sdk';
import { useEffect, useRef } from 'react';
export function logError(config, message, tag) {
  if (!config || !config.logManager || typeof config.logManager.error !== 'function' || !config.logLevel || config.logLevel < LogLevel.ERROR) {
    return;
  }

  config.logManager.error(message, tag);
}
export function logInfo(config, message, tag) {
  if (!config || !config.logManager || typeof config.logManager.info !== 'function' || !config.logLevel || config.logLevel < LogLevel.INFO) {
    return;
  }

  config.logManager.info(message, tag);
}
export function logWarn(config, message, tag) {
  if (!config || !config.logManager || typeof config.logManager.warning !== 'function' || !config.logLevel || config.logLevel < LogLevel.WARNING) {
    return;
  }

  config.logManager.warning(message, tag);
}
export function log(level, message, tag) {
  var now = new Date(); // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var getTwoDigit = function getTwoDigit(value) {
    return value.toString().length === 1 ? "0".concat(value) : value;
  };

  var out = "[".concat(getTwoDigit(now.getFullYear()), "-").concat(getTwoDigit(now.getMonth()), "-").concat(getTwoDigit(now.getDay()), " ").concat(getTwoDigit(now.getHours()), ":").concat(getTwoDigit(now.getMinutes()), "] [Flagship SDK] [").concat(LogLevel[level], "] [").concat(tag, "] : ").concat(message);
  console.log(out);
}
export var getModificationsFromCampaigns = function getModificationsFromCampaigns(campaigns) {
  var modifications = new Map();

  if (!campaigns || !Array.isArray(campaigns)) {
    return modifications;
  }

  campaigns.forEach(function (campaign) {
    var object = campaign.variation.modifications.value;

    for (var key in object) {
      var value = object[key];
      modifications.set(key, {
        key: key,
        campaignId: campaign.id,
        variationGroupId: campaign.variationGroupId,
        variationId: campaign.variation.id,
        isReference: campaign.variation.reference,
        value: value
      });
    }
  });
  return modifications;
};
export function uuidV4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
    var rand = Math.random() * 16 | 0;
    var value = char === 'x' ? rand : rand & 0x3 | 0x8;
    return value.toString(16);
  });
}
export function useNonInitialEffect(effect, deps) {
  var initialRender = useRef(true);
  useEffect(function () {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    if (typeof effect === 'function') {
      return effect();
    }
  }, deps);
}